module.exports = __webpack_public_path__ + "img/img-panel-multimarca.bf68de05.webp";